import BaseUIHandler from '../BaseUIHandler';
import Renderable from '../../../Component/Renderable';
import { StartAnimation } from '../../Animation/AnimationHelper';
import BaseUISystem, { UIEvent } from '../BaseUISystem';
import RenderSystem, { RenderSystemEvent } from '../../Render/RenderSystem';
import ElementComponent from '../../../Component/UI/Element';
import PIXIRenderer from '../../Render/PIXIRenderer';
import { AnimationClipEvent } from '../../Animation/AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TravelButton from '../../../Prefabs/UI/HUD/TravelButton';
import Point from '../../../Utility/Point';
import Game from '../../../Game';
import Element from '../../../Prototype/UI/Element';
import { PopupID } from '../../../State/UI/PopupID';

export default class WorldHUDTravelHandler extends BaseUIHandler {
    public worldNumber: number;
    constructor(uiSystem: BaseUISystem) {
        super(PopupID.WORLD_HUD_TRAVEL, uiSystem, false);
        this.alwaysVisible = true;

        this.system.scene.on(UIEvent.HIDE_HUD, this.hideHUD);
    }

    protected onCreate() {
        Game.store.getState().worldState.worldNumber;
        RenderSystem.on(RenderSystemEvent.RESIZE, this.onResize.bind(this));
        super.onCreate();
        const elementComponent: ElementComponent = this.element.getComponent(
            ElementComponent
        );
        //elementComponent.anchors = Point.Center.toVector4();
        elementComponent.pivot = Point.Zero;
        this.onResize();
        this.handleInteractables();
    }

    public handleInteractables(): void {
        const nextFarmButton: TravelButton = GameObject.Instantiate(
            TravelButton,
            {
                name: 'travel_forward',
                layout: {
                    anchors: [0.87, 0.72, 0.87, 0.72],
                },
            }
        );
        this.element.addChild(nextFarmButton);
        const previousFarmButton: TravelButton = GameObject.Instantiate(
            TravelButton,
            {
                name: 'travel_back',
                layout: {
                    anchors: [0.1, 0.72, 0.1, 0.72],
                },
                previous: true,
            }
        );
        this.element.addChild(previousFarmButton);
    }

    public destroy(): void {
        super.destroy();
    }

    public onResize(): void {
        if (!this.element.destroyed) {
            this.element.container.resize(
                PIXIRenderer.renderer.width,
                PIXIRenderer.renderer.height - PIXIRenderer.borderHeight * 2
            );

            this.element.children.forEach((child: GameObject) => {
                if (child instanceof Element) {
                    child.container.resize(
                        PIXIRenderer.renderer.width,
                        PIXIRenderer.renderer.height -
                            PIXIRenderer.borderHeight * 2
                    );
                }
            });
            this.element.getComponent(ElementComponent).offsets = [
                0,
                -PIXIRenderer.borderHeight,
                0,
                -PIXIRenderer.borderHeight,
            ];
        }
    }
    private readonly hideHUD = (value: boolean): void => {
        const mainRenderable: Renderable = this.element.getComponent<
            Renderable
        >(Renderable);

        StartAnimation(this.element, 'Alpha', {
            startAlpha: Number(value),
            endAlpha: Number(!value),
            duration: 250,
        }).once(
            AnimationClipEvent.COMPLETE,
            () => (mainRenderable.visible = !value)
        );
    };
}
